// import React, { useEffect, useState } from "react";
// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import HOST_URL from "../../../utils/Url";
// import Card from "@mui/material/Card";
// import {
//   Grid,
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   FormControl,
//   RadioGroup,
//   Radio,
//   Autocomplete,
//   ListItemText,
//   Modal,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import Switch from "@mui/material/Switch";
// import { useNavigate, useLocation } from "react-router-dom";
// import Chip from "@mui/material/Chip";
// import { useTranslation } from "react-i18next";
// import Paper from "@mui/material/Paper";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import CircularProgress from "@mui/material/CircularProgress";
// import api from "../../../utils/Url";
// import { useFormik } from "formik";
// import CustomLabel from "../../../CustomLable";
// import DownloadIcon from "@mui/icons-material/Download";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import moment from "moment";
// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
// import nopdf from '../../../assets/images/imagepreview.jpg';


// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "95%",
//   height: "85%",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };


// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function VehicleTrack() {
//   const [zones, setZones] = useState([]);
//   const [columns, setColumns] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [visible, setVisible] = useState(false);
//   const [isChecked, setIsChecked] = useState(false);

//   const [option, setOption] = useState([
//     { value: "-1", label: "Vehicle Type" },
//   ]);

//   const [isPrint, setPrint] = useState([]);

//   const [selectedFormat, setSelectedFormat] = useState<any>("pdf");

//   const [VnoOption, setVnoOption] = useState([
//     { value: -1, label: "Select Vehicle No " },
//   ]);

//   const [Period, setPeriod] = useState([{ value: -1, label: "Select Period" }]);
//   const [vNO, setVno] = useState([]);

//   const [vType, setVType] = useState([]);

//   const [IsDept, setDept] = useState([]);


//   const [selDay, setDay] = useState(false);
//   const [Shows, setShows] = useState<any>(false);
//   const [IsRep, setRep] = useState<any>("");

//   const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSelectedFormat((event.target as HTMLInputElement).value);
//   };

//   const downloadTabularExcel = () => {
//     if (!isPrint || isPrint.length === 0) {
//       console.error("No data to export to Tabular HTML.");
//       return;
//     }

//     // Prepare headers and rows for HTML table
//     const headers = [
//       "Date",
//       "Vehicle No",
//       "Driver",
//       "Mobile No",
//       "Department",
//       "Distance(KM)",
//       "Running",
//       "Idle",
//       "Start Time",
//       "End Time",
//       "Fuel Consumption",
//     ];

//     const rows = isPrint.map((item: any) => [
//       moment(item?.trackDate).format("DD-MM-YYYY") || "", // Vehicle No (formatted date)
//       item?.vehicleNo || "", // Vehicle Type
//       item?.driverName || "", // Driver
//       item?.mobileNo, // Driver Mobile No
//       item?.department,
//       item?.distanceKM,
//       item?.running,
//       item?.idle,
//       item?.startTime,
//       item?.endTime,
//       item?.fuelConsumption,
//     ]);

//     // Create HTML table
//     let html = `
//       <html>
//       <head>
//         <style>
//           table {
//             width: 100%;
//             border-collapse: collapse;
//             margin: 20px 0;
//           }
//           th {
//             background-color: #f2f2f2;
//             font-weight: bold;
//             padding: 8px;
//             text-align: left;
//             border: 1px solid #ddd;
//           }
//           td {
//             padding: 8px;
//             text-align: left;
//             border: 1px solid #ddd;
//           }
//           tr:nth-child(even) {
//             background-color: #f9f9f9;
//           }
//           tr:hover {
//             background-color: #f1f1f1;
//           }
//         </style>
//       </head>
//       <body>
//         <table>
//           <thead>
//             <tr>
//               ${headers.map((header) => `<th>${header}</th>`).join("")}
//             </tr>
//           </thead>
//           <tbody>
//             ${rows
//         .map(
//           (row) =>
//             `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`
//         )
//         .join("")}
//           </tbody>
//         </table>
//       </body>
//       </html>
//     `;

//     // Create a Blob from the HTML string and trigger the download
//     const blob = new Blob([html], { type: "text/html" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "Vehicle_data_tabular.html";
//     link.click();
//   };

//   const downloadExcel = () => {
//     if (!isPrint || isPrint.length === 0) {
//       console.error("No data to export to Excel.");
//       return;
//     }

//     const ws = XLSX.utils.json_to_sheet(isPrint);

//     const headers = Object.keys(isPrint[0]);

//     headers.forEach((header, index) => {
//       const cellAddress = `${String.fromCharCode(65 + index)}1`;
//     });

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "vehicles");

//     XLSX.writeFile(wb, "Vehicle_data.xlsx");
//   };

//   // Function to download PDF
//   const downloadPDF = async () => {
//     const collectData = {
//       Str1: "",
//       Str2: isChecked ? "y" : "n",
//       Str3: "",
//       Str4: "",
//       Str5: "",
//       Str6: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: formik.values.days || 0,
//       intnotnullvalue1: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       list1: vNO ? vNO : [],
//       listInt1: vType ? vType : [],
//       list2: [],
//       listInt2: [],
//       listInt12: [],
//       date1: formik.values.startDate
//         ? formik.values.startDate
//         : formik.values.fromDate,
//       date2: formik.values.endDate
//         ? formik.values.endDate
//         : formik.values.toDate,
//       date3: null,
//       date4: null,
//       dec1: null,
//       dec2: null,
//       dec3: null,
//       dec4: null,
//       Flag: true,
//       Data: "",
//       Success: false,
//       Error: "",
//       SelectPerindex: formik.values.index,
//       selectedPeriod: {
//         index: formik.values.index || 2,
//         startDate: formik.values.startDate || previousDate,
//         endDate: formik.values.endDate || previousDate,
//         daysOnly: formik.values.daysOnly || true,
//         displayLabel: formik.values.displayLabel || "Yesterday",
//       },
//       listPeriod: Period,
//       SelectPerindex1: 0,
//       selectedPeriod1: {
//         index: 0,
//         startDate: previousDate,
//         endDate: previousDate,
//         daysOnly: false,
//         displayLabel: "",
//       },
//       listPeriod1: [],
//       Show: false,
//       EmpName: "",
//       ZoneName: "",
//       DepartmentName: formik.values.DeptName || "",
//       ExportOption: ".pdf",
//       All: false,
//       ConditionStr1: "Skip Records speed 0 and distance 0",
//       ConditionStr2: "",
//       Condition1: false,
//       Condition2: selDay ? selDay : false,
//       ExpOption: [
//         {
//           ext: ".pdf",
//           extname: "Pdf",
//         },
//         {
//           ext: ".xls",
//           extname: "Excel",
//         },
//       ],
//       cancel: {
//         waitHandle: {
//           handle: {},
//           safeWaitHandle: {},
//         },
//       },
//     };
//     // console.log("collectData " + JSON.stringify(collectData));
//     const response = await api.post(
//       `VehicleMoving/VehicleMovingTrackStatusdetnew`,
//       collectData
//     );


//     if (response) {
//       const base64Data = response.data;


//       const byteCharacters = atob(base64Data);
//       const byteArrays = [];


//       for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
//         const slice = byteCharacters.slice(offset, offset + 1024);
//         const byteNumbers = new Array(slice.length);
//         for (let i = 0; i < slice.length; i++) {
//           byteNumbers[i] = slice.charCodeAt(i);
//         }
//         byteArrays.push(new Uint8Array(byteNumbers));
//       }


//       const blob = new Blob(byteArrays, { type: "application/pdf" });


//       const url = URL.createObjectURL(blob);


//       const link = document.createElement("a");
//       link.href = url;
//       link.download = "VehicleTrack.pdf";
//       document.body.appendChild(link);
//       link.click();


//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);

//       //console.log('Printdata',data)
//       // setShows(true);
//       // setRep(response.data);

//     }
//   };
//   // Handle Download Button Click
//   const handleDownload = () => {
//     if (selectedFormat === "excel") {
//       downloadExcel();
//     } else if (selectedFormat === "pdf") {
//       downloadPDF();
//     } else if (selectedFormat === "tabular") {
//       downloadTabularExcel();
//     }
//   };

//   let navigate = useNavigate();
//   const { t } = useTranslation();

//   useEffect(() => {
//     getData();
//     getPeriod();
//     getDepartment();

//     getVehicleNo();
//   }, []);

//   const getPeriod = () => {
//     api.get(`Period/GetPeriods?type=Period&daysOnly=false`).then((res) => {
//       const arr = res?.data?.map((item: any) => ({
//         label: item?.displayLabel,
//         value: item?.index,
//         startDate: item?.startDate,
//         endDate: item?.endDate,
//         daysOnly: item?.daysOnly,
//         displayLabel: item?.displayLabel,
//         index: item?.index,
//       }));
//       setPeriod(arr);
//     });
//   };



//   const getDepartment = () => {

//     const collectData = {
//       "departmentId": -1,
//       "departmentName": ""
//     }
//     api.post(`Department/GetDepartmentmaster`, collectData).then((res) => {
//       const arr = res?.data?.data?.map((item: any) => ({
//         label: item?.departmentName,
//         value: item?.departmentId,

//       }));
//       setDept(arr);
//     });
//   };




//   const getVehicleNo = () => {
//     const collectData = {
//       orderby: "",
//       pageNo: 0,
//       pageSize: 0,
//       intnotnullvalue1: 0,
//       userId: "",

//       str1: "",
//       str2: "",
//       str3: "",
//       str4: "",
//       str5: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       date1: new Date().toISOString(),
//       date2: new Date().toISOString(),
//       date3: new Date().toISOString(),
//       date4: new Date().toISOString(),
//       dec1: 0,
//       dec2: 0,
//       dec3: 0,
//       dec4: 0,
//       flag: true,
//       data: "",
//       success: true,
//       error: "",
//       selectPerindex: 0,
//       show: true,
//     };
//     api.post(`Dashboard/GetvVehicleNo`, collectData).then((res) => {
//       const arr = res?.data?.data.map((item: any) => ({
//         label: item.vehicleNo,
//         value: item.vehicleNo,
//       }));
//       setVnoOption(arr);
//     });
//   };

//   const getData = () => {
//     const collectData = {
//       vehicleTypeId: -1,
//       vehicleTypename: "",
//     };
//     api.post(`VehicleType/GetVehicleType`, collectData).then((res) => {
//       const arr = res?.data?.data.map((item: any) => ({
//         label: item.vehicleTypename,
//         value: item.vehicleTypeId,
//       }));
//       setOption(arr);
//     });
//   };
//   let currentDate = new Date();

//   currentDate.setDate(currentDate.getDate() - 1);

//   let previousDate = currentDate.toISOString();

//   const fetchZonesData = async () => {
//     try {
//       const collectData = {
//         Str1: "",
//         Str2: isChecked ? "y" : "n",
//         Str3: "",
//         Str4: "",
//         Str5: "",
//         Str6: "",
//         intvalue1: 0,
//         intvalue2: 0,
//         intvalue3: 0,
//         intvalue4: formik.values.days || 0,
//         intnotnullvalue1: 0,
//         intnotnullvalue2: 0,
//         intnotnullvalue3: 0,
//         list1: vNO ? vNO : [],
//         listInt1: vType ? vType : [],
//         list2: [],
//         listInt2: [],
//         listInt12: [],
//         date1: formik.values.startDate
//           ? formik.values.startDate
//           : formik.values.fromDate,
//         date2: formik.values.endDate
//           ? formik.values.endDate
//           : formik.values.toDate,
//         date3: null,
//         date4: null,
//         dec1: null,
//         dec2: null,
//         dec3: null,
//         dec4: null,
//         Flag: true,
//         Data: "",
//         Success: false,
//         Error: "",
//         SelectPerindex: formik.values.index,
//         selectedPeriod: {
//           index: formik.values.index || 2,
//           startDate: formik.values.startDate || previousDate,
//           endDate: formik.values.endDate || previousDate,
//           daysOnly: formik.values.daysOnly || true,
//           displayLabel: formik.values.displayLabel || "Yesterday",
//         },
//         listPeriod: Period,
//         SelectPerindex1: 0,
//         selectedPeriod1: {
//           index: 0,
//           startDate: previousDate,
//           endDate: previousDate,
//           daysOnly: false,
//           displayLabel: "",
//         },
//         listPeriod1: [],
//         Show: true,
//         EmpName: "",
//         ZoneName: "",
//         DepartmentName: formik.values.DeptName || "",
//         ExportOption: ".pdf",
//         All: false,
//         ConditionStr1: "Skip Records speed 0 and distance 0",
//         ConditionStr2: "",
//         Condition1: false,
//         Condition2: selDay ? selDay : false,
//         ExpOption: [
//           {
//             ext: ".pdf",
//             extname: "Pdf",
//           },
//           {
//             ext: ".xls",
//             extname: "Excel",
//           },
//         ],
//         cancel: {
//           waitHandle: {
//             handle: {},
//             safeWaitHandle: {},
//           },
//         },
//       };
//       const response = await api.post(
//         `VehicleMoving/VehicleMovingTrackStatusdetnew`,
//         collectData
//       );
//       const data = response?.data;

//       const Print = data.map((item: any, index: any) => ({
//         ...item,
//       }));
//       setPrint(Print);
//       const zonesWithIds = data.map((zone: any, index: any) => ({
//         ...zone,
//         serialNo: index + 1,
//         id: index + 1,
//       }));
//       setZones(zonesWithIds);
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           {
//             field: "serialNo",
//             headerName: t("text.SrNo"),
//             flex: 0.5,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "trackDate",
//             headerName: t("text.Date"),
//             flex: 1.3,
//             cellClassName: "wrap-text", // Added here
//             renderCell: (params) => {
//               return moment(params.row.trackDate).format("DD-MM-YYYY");
//             },
//           },
//           {
//             field: "vehicleNo",
//             headerName: t("text.VehicleNo"),
//             flex: 1.2,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "driverName",
//             headerName: t("text.Driver"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "mobileNo",
//             headerName: t("text.MobileNo"),
//             flex: 1.3,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "department",
//             headerName: t("text.Department"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "distanceKM",
//             headerName: t("text.Distance"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             align: 'right',
//             headerAlign: 'right',
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "running",
//             headerName: t("text.Running"),
//             flex: 1.5,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "idle",
//             headerName: t("text.Idle"),
//             flex: 1.5,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "startTime",
//             headerName: t("text.StartTime"),
//             flex: 1.5,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "endTime",
//             headerName: t("text.EndTime"),
//             flex: 1.5,
//             headerClassName: "MuiDataGrid-colCell",
//             cellClassName: "wrap-text", // Added here
//           },
//           {
//             field: "fuelConsumption",
//             headerName: t("text.FuelConsumption"),
//             flex: 1,
//             headerClassName: "MuiDataGrid-colCell",
//             align: 'right',
//             headerAlign: 'right',
//             cellClassName: "wrap-text", // Added here
//           },
//         ];
//         setColumns(columns as any);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       // setLoading(false);
//     }
//   };

//   const adjustedColumns = columns.map((column: any) => ({
//     ...column,
//   }));


//   const styles = `
//   .wrap-text {
//     white-space: normal !important;
//     word-wrap: break-word !important;
//     overflow-wrap: break-word !important;
//   }
// `;

//   document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

//   const formik = useFormik({
//     initialValues: {
//       genderID: -1,
//       genderName: "",
//       genderCode: "",
//       fromDate: "",
//       toDate: "",
//       days: 0,
//       parentId: 0,
//       startDate: "",
//       endDate: "",
//       daysOnly: false,
//       displayLabel: "",
//       index: 0,
//       DeptName: 0
//     },
//     onSubmit: async (values) => {
//       //   const response = await api.post(
//       //     `Gender/AddUpdateGenderMaster`,
//       //     values
//       //   );
//       //   try {
//       //     setToaster(false);
//       //     toast.success(response.data.mesg);
//       //     navigate("/master/GenderMaster");
//       //   } catch (error) {
//       //     setToaster(true);
//       //     toast.error(response.data.mesg);
//       //   }
//     },
//   });

//   return (
//     <>
//       <Card
//         style={{
//           width: "100%",
//           // height: "100%",
//           backgroundColor: "#E9FDEE",
//           // border: ".5px solid #FF7722 ",
//           marginTop: "3vh",
//         }}
//       >
//         <Paper
//           sx={{
//             width: "100%",
//             overflow: "hidden",
//             "& .MuiDataGrid-colCell": {
//               backgroundColor: `var(--grid-headerBackground)`,
//               color: `var(--grid-headerColor)`,
//               fontSize: 17,
//               fontWeight: 900,
//             },
//           }}
//           style={{ padding: "10px" }}
//         >
//           <ConfirmDialog />

//           <Typography
//             gutterBottom
//             variant="h5"
//             component="div"
//             sx={{ padding: "20px" }}
//             align="left"
//           >
//             {t("text.VehicleTrack")}
//           </Typography>
//           <Divider />

//           <Box height={10} />

//           <Grid item xs={12} container spacing={2} sx={{ marginTop: "3vh" }}>
//             <Grid item xs={12} sm={4} lg={4}>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     checked={isChecked}
//                     onChange={(e) => {
//                       setIsChecked(e.target.checked);
//                     }}
//                   />
//                 }
//                 label="For All Vehicles"
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}>
//               <FormControl component="fieldset">
//                 <RadioGroup
//                   row
//                   value={selectedFormat}
//                   onChange={handleFormatChange}
//                 >
//                   <FormControlLabel
//                     value="pdf"
//                     control={<Radio />}
//                     label="PDF"
//                   />
//                   <FormControlLabel
//                     value="excel"
//                     control={<Radio />}
//                     label="Excel"
//                   />
//                   <FormControlLabel
//                     value="tabular"
//                     control={<Radio />}
//                     label="Tabular Excel"
//                   />
//                 </RadioGroup>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}>
//               <Box display="flex" alignItems="center">
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={selDay}
//                       onChange={(e) => {
//                         setDay(e.target.checked);
//                       }}
//                     />
//                   }
//                   label="Vehicle Running Less than:"
//                 />
//                 <TextField
//                   variant="outlined"
//                   id="days"
//                   name="days"
//                   type="number"
//                   inputProps={{ min: 0 }}
//                   value={formik.values.days}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   onFocus={(e) => e.target.select()}
//                   style={{ width: "60px" }}
//                 />
//                 days
//               </Box>
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Autocomplete
//                 disablePortal
//                 id="combo-box-demo"
//                 options={[{ value: -1, label: "Custom" }].concat(Period)}
//                 fullWidth
//                 size="small"
//                 onChange={(event, newValue: any) => {
//                   // console.log(newValue?.value);

//                   if (newValue && newValue.value !== undefined) {
//                     if (newValue.value === -1) {
//                       formik.setFieldValue("parentId", newValue.value || null);
//                     } else {
//                       formik.setFieldValue("index", newValue.index || null);
//                       formik.setFieldValue(
//                         "startDate",
//                         newValue.startDate || ""
//                       );
//                       formik.setFieldValue("endDate", newValue.endDate || "");
//                       formik.setFieldValue(
//                         "daysOnly",
//                         newValue.daysOnly || false
//                       );
//                       formik.setFieldValue(
//                         "displayLabel",
//                         newValue.label || ""
//                       );
//                     }
//                   } else {
//                     // Handle case when newValue is null or undefined
//                     console.error("newValue is null or undefined");
//                     // Optionally reset form fields or handle the case here
//                   }
//                 }}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel text={t("text.Period")} required={false} />
//                     }
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <TextField
//                 type="date"
//                 id="fromDate"
//                 name="fromDate"
//                 label={
//                   <CustomLabel text={t("text.FromDate")} required={false} />
//                 }
//                 value={formik.values.fromDate}
//                 placeholder={t("text.FromDate")}
//                 size="small"
//                 fullWidth
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 InputLabelProps={{ shrink: true }}
//                 disabled={formik.values.parentId !== -1}
//                 InputProps={{
//                   readOnly: formik.values.parentId !== -1,
//                 }}
//               />
//             </Grid>

//             {/* To Date Input */}
//             <Grid xs={12} sm={4} md={4} item>
//               <TextField
//                 type="date"
//                 id="toDate"
//                 name="toDate"
//                 label={<CustomLabel text={t("text.ToDate")} required={false} />}
//                 value={formik.values.toDate}
//                 placeholder={t("text.ToDate")}
//                 size="small"
//                 fullWidth
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 InputLabelProps={{ shrink: true }}
//                 disabled={formik.values.parentId !== -1}
//                 InputProps={{
//                   readOnly: formik.values.parentId !== -1,
//                 }}
//               />
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Autocomplete
//                 multiple
//                 disablePortal
//                 id="combo-box-demo"
//                 options={option}
//                 fullWidth
//                 size="small"
//                 onChange={(event, newValue: any) => {
//                   const selectedVType = newValue.map((item: any) => item.value);
//                   setVType(selectedVType);
//                 }}
//                 disableCloseOnSelect
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>
//                     <Checkbox style={{ marginRight: 8 }} checked={selected} />
//                     <ListItemText primary={option.label} />
//                   </li>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel
//                         text={t("text.VehicleType")}
//                         required={false}
//                       />
//                     }
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}>
//               <Autocomplete
//                 multiple
//                 disablePortal
//                 id="combo-box-demo"
//                 options={VnoOption}
//                 fullWidth
//                 size="small"
//                 onChange={(event: any, newValue: any) => {
//                   const selectedVno = newValue.map((item: any) => item.value);
//                   setVno(selectedVno);
//                 }}
//                 disableCloseOnSelect
//                 renderOption={(props, option, { selected }) => (
//                   <li {...props}>
//                     <Checkbox style={{ marginRight: 8 }} checked={selected} />
//                     <ListItemText primary={option.label} />
//                   </li>
//                 )}
//                 renderInput={(params: any) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel
//                         text={t("text.VehicleNos1")}
//                         required={false}
//                       />
//                     }
//                   />
//                 )}
//                 popupIcon={null}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4} lg={4}>
//               <Autocomplete
//                 // multiple
//                 disablePortal
//                 id="combo-box-demo"
//                 options={IsDept}
//                 fullWidth
//                 size="small"
//                 onChange={(event: any, newValue: any) => {
//                   formik.setFieldValue('DeptName', newValue.label)
//                 }}

//                 renderInput={(params: any) => (
//                   <TextField
//                     {...params}
//                     label={
//                       <CustomLabel
//                         text={t("text.SelectDepartment")}
//                         required={false}
//                       />
//                     }
//                   />
//                 )}
//               // popupIcon={null}
//               />
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Button
//                 type="submit"
//                 fullWidth
//                 style={{
//                   backgroundColor: `var(--header-background)`,
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 onClick={() => {
//                   const selectedPeriod = formik.values.fromDate ? formik.values.fromDate : formik.values.index;

//                   if (!selectedPeriod) {

//                     alert("Please select a period. or custom date");
//                   } else {

//                     fetchZonesData();
//                     setVisible(true);
//                   }
//                 }}
//                 startIcon={<VisibilityIcon />}
//               >
//                 Show
//               </Button>
//             </Grid>

//             <Grid xs={12} sm={4} md={4} item>
//               <Button
//                 type="button"
//                 fullWidth
//                 style={{
//                   backgroundColor: `#f44336`,
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 startIcon={<RefreshIcon />}
//                 onClick={() => {
//                   formik.resetForm();
//                 }}
//               >
//                 Reset
//               </Button>
//             </Grid>

//             <Grid item xs={12} sm={4} md={4}>
//               <Button
//                 type="button"
//                 fullWidth
//                 style={{
//                   backgroundColor: "#4caf50",
//                   color: "white",
//                   marginTop: "10px",
//                 }}
//                 startIcon={<DownloadIcon />}
//                 onClick={handleDownload}
//               >
//                 Download
//               </Button>
//             </Grid>
//           </Grid>

//           <Grid
//             item
//             xs={12}
//             container
//             spacing={2}
//             sx={{ marginTop: "3%", justifyContent: "center" }}
//           >
//             {visible && (
//               <Grid item xs={12} sm={12} lg={12}>
//                 {isLoading ? (
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                     }}
//                   >
//                     <CircularProgress />
//                   </div>
//                 ) : (
//                   <DataGrid
//                     rows={zones}
//                     columns={adjustedColumns}
//                     rowSpacingType="border"
//                     autoHeight
//                     slots={{
//                       toolbar: GridToolbar,
//                     }}
//                     pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                       value: size,
//                       label: `${size}`,
//                     }))}
//                     initialState={{
//                       pagination: { paginationModel: { pageSize: 5 } },
//                     }}
//                     slotProps={{
//                       toolbar: {
//                         showQuickFilter: true,
//                       },
//                     }}
//                     sx={{
//                       border: 0,
//                       "& .MuiDataGrid-columnHeaders": {
//                         backgroundColor: "#42b6f5", // Header background color
//                         color: "white", // Header text color
//                       },
//                       "& .MuiDataGrid-columnHeaderTitle": {
//                         color: "white", // Header title text color
//                         fontSize: '14px'
//                       },
//                       "& .MuiDataGrid-cell": {
//                         whiteSpace: "normal", // Ensure text wraps inside the cell
//                         wordWrap: "break-word", // Break words to avoid overflow
//                         overflowWrap: "break-word", // Ensure long words wrap correctly
//                       },
//                     }}
//                   />
//                 )}
//               </Grid>
//             )}
//           </Grid>


//           <Modal open={Shows} onClose={() => setShows(false)}>
//             <Box sx={style}>
//               {IsRep ? (
//                 <embed src={`data:application/pdf;base64,${IsRep}`} type="application/pdf" style={{ width: "100%", height: "100%" }} />
//               ) : (
//                 <img
//                   src={nopdf}
//                   alt="No Preview"
//                   style={{ width: "100%", height: "100%" }}
//                 />
//               )}
//             </Box>
//           </Modal>
//         </Paper>
//       </Card>
//       <ToastApp />
//     </>
//   );
// }


import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import Card from "@mui/material/Card";
import {
  Grid,
  Box,
  Button,
  Divider,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  Autocomplete,
  ListItemText,
  Modal,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import moment from "moment";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import api from "../../../utils/Url";
import CustomLabel from "../../../CustomLable";
import ToastApp from "../../../ToastApp";
import nopdf from '../../../assets/images/imagepreview.jpg';

// Define types for our data structures
interface OptionType {
  value: string | number;
  label: string;
  [key: string]: any;
}

interface PeriodType extends OptionType {
  startDate?: string;
  endDate?: string;
  daysOnly?: boolean;
  displayLabel?: string;
  index?: number;
}

interface VehicleTrackData {
  serialNo: number;
  id: number;
  trackDate: string;
  vehicleNo: string;
  driverName: string;
  mobileNo: string;
  department: string;
  distanceKM: number;
  running: string;
  idle: string;
  startTime: string;
  endTime: string;
  fuelConsumption: number;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  height: '85%',
  bgcolor: '#f5f5f5',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

const VehicleTrack: React.FC = () => {
  const [zones, setZones] = useState<VehicleTrackData[]>([]);
  const [columns, setColumns] = useState<GridColDef[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const [option, setOption] = useState<OptionType[]>([
    { value: "-1", label: "Vehicle Type" },
  ]);

  const [isPrint, setPrint] = useState<any[]>([]);
  const [selectedFormat, setSelectedFormat] = useState<string>("pdf");
  const [VnoOption, setVnoOption] = useState<OptionType[]>([
    { value: -1, label: "Select Vehicle No " },
  ]);
  const [Period, setPeriod] = useState<PeriodType[]>([{ value: -1, label: "Select Period" }]);
  const [vNO, setVno] = useState<(string | number)[]>([]);
  const [vType, setVType] = useState<(string | number)[]>([]);
  const [IsDept, setDept] = useState<OptionType[]>([]);
  const [selDay, setDay] = useState(false);
  const [Shows, setShows] = useState<boolean>(false);
  const [IsRep, setRep] = useState<string>("");

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };

  const downloadTabularExcel = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to Tabular HTML.");
      return;
    }

    const headers = [
      "Date",
      "Vehicle No",
      "Driver",
      "Mobile No",
      "Department",
      "Distance(KM)",
      "Running",
      "Idle",
      "Start Time",
      "End Time",
      "Fuel Consumption",
    ];

    const rows = isPrint.map((item: any) => [
      moment(item?.trackDate).format("DD-MM-YYYY") || "",
      item?.vehicleNo || "",
      item?.driverName || "",
      item?.mobileNo,
      item?.department,
      item?.distanceKM,
      item?.running,
      item?.idle,
      item?.startTime,
      item?.endTime,
      item?.fuelConsumption,
    ]);

    let html = `
      <html>
      <head>
        <style>
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
            padding: 8px;
            text-align: left;
            border: 1px solid #ddd;
          }
          td {
            padding: 8px;
            text-align: left;
            border: 1px solid #ddd;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          tr:hover {
            background-color: #f1f1f1;
          }
        </style>
      </head>
      <body>
        <table>
          <thead>
            <tr>
              ${headers.map((header) => `<th>${header}</th>`).join("")}
            </tr>
          </thead>
          <tbody>
            ${rows
        .map(
          (row) =>
            `<tr>${row.map((cell) => `<td>${cell}</td>`).join("")}</tr>`
        )
        .join("")}
          </tbody>
        </table>
      </body>
      </html>
    `;

    const blob = new Blob([html], { type: "text/html" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Vehicle_data_tabular.html";
    link.click();
  };

  const downloadExcel = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to Excel.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(isPrint);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "vehicles");
    XLSX.writeFile(wb, "Vehicle_data.xlsx");
  };

  const downloadPDF = async () => {
    const collectData = {
      Str1: "",
      Str2: isChecked ? "y" : "n",
      Str3: "",
      Str4: "",
      Str5: "",
      Str6: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: formik.values.days || 0,
      intnotnullvalue1: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      list1: vNO ? vNO : [],
      listInt1: vType ? vType : [],
      list2: [],
      listInt2: [],
      listInt12: [],
      date1: formik.values.startDate || formik.values.fromDate,
      date2: formik.values.endDate || formik.values.toDate,
      date3: null,
      date4: null,
      dec1: null,
      dec2: null,
      dec3: null,
      dec4: null,
      Flag: true,
      Data: "",
      Success: false,
      Error: "",
      SelectPerindex: formik.values.index,
      selectedPeriod: {
        index: formik.values.index || 2,
        startDate: formik.values.startDate || previousDate,
        endDate: formik.values.endDate || previousDate,
        daysOnly: formik.values.daysOnly || true,
        displayLabel: formik.values.displayLabel || "Yesterday",
      },
      listPeriod: Period,
      SelectPerindex1: 0,
      selectedPeriod1: {
        index: 0,
        startDate: previousDate,
        endDate: previousDate,
        daysOnly: false,
        displayLabel: "",
      },
      listPeriod1: [],
      Show: false,
      EmpName: "",
      ZoneName: "",
      DepartmentName: formik.values.DeptName || "",
      ExportOption: ".pdf",
      All: false,
      ConditionStr1: "Skip Records speed 0 and distance 0",
      ConditionStr2: "",
      Condition1: false,
      Condition2: selDay ? selDay : false,
      ExpOption: [
        {
          ext: ".pdf",
          extname: "Pdf",
        },
        {
          ext: ".xls",
          extname: "Excel",
        },
      ],
      cancel: {
        waitHandle: {
          handle: {},
          safeWaitHandle: {},
        },
      },
    };

    try {
      const response = await api.post(
        `VehicleMoving/VehicleMovingTrackStatusdetnew`,
        collectData
      );

      if (response.data) {
        const base64Data = response.data;
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          byteArrays.push(new Uint8Array(byteNumbers));
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "VehicleTrack.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const handleDownload = () => {
    if (selectedFormat === "excel") {
      downloadExcel();
    } else if (selectedFormat === "pdf") {
      downloadPDF();
    } else if (selectedFormat === "tabular") {
      downloadTabularExcel();
    }
  };

  const navigate = useNavigate();
  const { t } = useTranslation();

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1);
  const previousDate = currentDate.toISOString();

  useEffect(() => {
    getData();
    getPeriod();
    getDepartment();
    getVehicleNo();
  }, []);

  const getPeriod = () => {
    api.get(`Period/GetPeriods?type=Period&daysOnly=false`).then((res) => {
      const arr: PeriodType[] = res?.data?.map((item: any) => ({
        label: item?.displayLabel,
        value: item?.index,
        startDate: item?.startDate,
        endDate: item?.endDate,
        daysOnly: item?.daysOnly,
        displayLabel: item?.displayLabel,
        index: item?.index,
      }));
      setPeriod(arr);
    });
  };

  const getDepartment = () => {
    const collectData = {
      departmentId: -1,
      departmentName: ""
    };
    api.post(`Department/GetDepartmentmaster`, collectData).then((res) => {
      const arr: OptionType[] = res?.data?.data?.map((item: any) => ({
        label: item?.departmentName,
        value: item?.departmentId,
      }));
      setDept(arr);
    });
  };

  const getVehicleNo = () => {
    const collectData = {
      orderby: "",
      pageNo: 0,
      pageSize: 0,
      intnotnullvalue1: 0,
      userId: "",
      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      date1: new Date().toISOString(),
      date2: new Date().toISOString(),
      date3: new Date().toISOString(),
      date4: new Date().toISOString(),
      dec1: 0,
      dec2: 0,
      dec3: 0,
      dec4: 0,
      flag: true,
      data: "",
      success: true,
      error: "",
      selectPerindex: 0,
      show: true,
    };
    api.post(`Dashboard/GetvVehicleNo`, collectData).then((res) => {
      const arr: OptionType[] = res?.data?.data.map((item: any) => ({
        label: item.vehicleNo,
        value: item.vehicleNo,
      }));
      setVnoOption(arr);
    });
  };

  const getData = () => {
    const collectData = {
      vehicleTypeId: -1,
      vehicleTypename: "",
    };
    api.post(`VehicleType/GetVehicleType`, collectData).then((res) => {
      const arr: OptionType[] = res?.data?.data.map((item: any) => ({
        label: item.vehicleTypename,
        value: item.vehicleTypeId,
      }));
      setOption(arr);
    });
  };

  const fetchZonesData = async () => {
    try {
      const collectData = {
        Str1: "",
        Str2: isChecked ? "y" : "n",
        Str3: "",
        Str4: "",
        Str5: "",
        Str6: "",
        intvalue1: 0,
        intvalue2: 0,
        intvalue3: 0,
        intvalue4: formik.values.days || 0,
        intnotnullvalue1: 0,
        intnotnullvalue2: 0,
        intnotnullvalue3: 0,
        list1: vNO ? vNO : [],
        listInt1: vType ? vType : [],
        list2: [],
        listInt2: [],
        listInt12: [],
        date1: formik.values.startDate || formik.values.fromDate,
        date2: formik.values.endDate || formik.values.toDate,
        date3: null,
        date4: null,
        dec1: null,
        dec2: null,
        dec3: null,
        dec4: null,
        Flag: true,
        Data: "",
        Success: false,
        Error: "",
        SelectPerindex: formik.values.index,
        selectedPeriod: {
          index: formik.values.index || 2,
          startDate: formik.values.startDate || previousDate,
          endDate: formik.values.endDate || previousDate,
          daysOnly: formik.values.daysOnly || true,
          displayLabel: formik.values.displayLabel || "Yesterday",
        },
        listPeriod: Period,
        SelectPerindex1: 0,
        selectedPeriod1: {
          index: 0,
          startDate: previousDate,
          endDate: previousDate,
          daysOnly: false,
          displayLabel: "",
        },
        listPeriod1: [],
        Show: true,
        EmpName: "",
        ZoneName: "",
        DepartmentName: formik.values.DeptName || "",
        ExportOption: ".pdf",
        All: false,
        ConditionStr1: "Skip Records speed 0 and distance 0",
        ConditionStr2: "",
        Condition1: false,
        Condition2: selDay ? selDay : false,
        ExpOption: [
          {
            ext: ".pdf",
            extname: "Pdf",
          },
          {
            ext: ".xls",
            extname: "Excel",
          },
        ],
        cancel: {
          waitHandle: {
            handle: {},
            safeWaitHandle: {},
          },
        },
      };

      const response = await api.post(
        `VehicleMoving/VehicleMovingTrackStatusdetnew`,
        collectData
      );
      const data = response?.data;

      const Print = data.map((item: any, index: number) => ({
        ...item,
      }));
      setPrint(Print);

      const zonesWithIds: VehicleTrackData[] = data.map((zone: any, index: number) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
      }));
      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "trackDate",
            headerName: t("text.Date"),
            flex: 1.3,
            cellClassName: "wrap-text",
            renderCell: (params) => {
              return moment(params.row.trackDate).format("DD-MM-YYYY");
            },
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNo"),
            flex: 1.2,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "driverName",
            headerName: t("text.Driver"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "mobileNo",
            headerName: t("text.MobileNo"),
            flex: 1.3,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "department",
            headerName: t("text.Department"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "distanceKM",
            headerName: t("text.Distance"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            align: 'right',
            headerAlign: 'right',
            cellClassName: "wrap-text",
          },
          {
            field: "running",
            headerName: t("text.Running"),
            flex: 1.5,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "idle",
            headerName: t("text.Idle"),
            flex: 1.5,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "startTime",
            headerName: t("text.StartTime"),
            flex: 1.5,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "endTime",
            headerName: t("text.EndTime"),
            flex: 1.5,
            headerClassName: "MuiDataGrid-colCell",
            cellClassName: "wrap-text",
          },
          {
            field: "fuelConsumption",
            headerName: t("text.FuelConsumption"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            align: 'right',
            headerAlign: 'right',
            cellClassName: "wrap-text",
          },
        ];
        setColumns(columns);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const styles = `
    .wrap-text {
      white-space: normal !important;
      word-wrap: break-word !important;
      overflow-wrap: break-word !important;
    }
  `;

  document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);

  const formik = useFormik({
    initialValues: {
      genderID: -1,
      genderName: "",
      genderCode: "",
      fromDate: "",
      toDate: "",
      days: 0,
      parentId: 0,
      startDate: "",
      endDate: "",
      daysOnly: false,
      displayLabel: "",
      index: 0,
      DeptName: ""
    },
    onSubmit: async (values) => { },
  });

  interface CustomMultiSelectAutocompleteProps {
    options: OptionType[];
    label: string;
    onChange: (event: any, newValue: OptionType[]) => void;
    value: OptionType[];
    [key: string]: any;
  }

  const CustomMultiSelectAutocomplete: React.FC<CustomMultiSelectAutocompleteProps> = ({
    options,
    label,
    onChange,
    value,
    ...props
  }) => {
    const allSelected = value?.length === options?.filter(opt => opt.value !== "-1" && opt.value !== -1).length;

    return (
      <Autocomplete
        multiple
        disablePortal
        size="small"
        options={options}
        value={value}
        onChange={onChange}
        disableCloseOnSelect
        renderOption={(props, option, { selected }) => {
          if (option.value === "-1" || option.value === -1) {
            return (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={allSelected}
                  indeterminate={!allSelected && value?.length > 0}
                />
                <ListItemText primary="Select All" />
              </li>
            );
          }
          return (
            <li {...props}>
              <Checkbox style={{ marginRight: 8 }} checked={selected} />
              <ListItemText primary={option.label} />
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={<CustomLabel text={label} required={false} />}
          />
        )}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.label}
        {...props}
      />
    );
  };

  const handleVehicleTypeChange = (event: any, newValue: OptionType[]) => {
    if (newValue && newValue.find((option) => option.value === "-1")) {
      const allOptions = option.filter(opt => opt.value !== "-1");
      setVType(allOptions.map(item => item.value));
      return;
    }

    const selectedVType = newValue.map(item => item.value);
    setVType(selectedVType);
  };

  const handleVehicleNoChange = (event: any, newValue: OptionType[]) => {
    if (newValue && newValue.find((option) => option.value === -1)) {
      const allOptions = VnoOption.filter(opt => opt.value !== -1);
      setVno(allOptions.map(item => item.value));
      return;
    }

    const selectedVno = newValue.map(item => item.value);
    setVno(selectedVno);
  };

  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "#E9FDEE",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.VehicleTrack")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Grid item xs={12} container spacing={2} sx={{ marginTop: "3vh" }}>
            <Grid item xs={12} sm={4} lg={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={(e) => {
                      setIsChecked(e.target.checked);
                    }}
                  />
                }
                label="For All Vehicles"
              />
            </Grid>

            <Grid item xs={12} sm={4} lg={4}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={selectedFormat}
                  onChange={handleFormatChange}
                >
                  <FormControlLabel
                    value="pdf"
                    control={<Radio />}
                    label="PDF"
                  />
                  <FormControlLabel
                    value="excel"
                    control={<Radio />}
                    label="Excel"
                  />
                  <FormControlLabel
                    value="tabular"
                    control={<Radio />}
                    label="Tabular Excel"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4} lg={4}>
              <Box display="flex" alignItems="center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selDay}
                      onChange={(e) => {
                        setDay(e.target.checked);
                      }}
                    />
                  }
                  label="Vehicle Running Less than:"
                />
                <TextField
                  variant="outlined"
                  id="days"
                  name="days"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={formik.values.days}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onFocus={(e) => e.target.select()}
                  style={{ width: "60px" }}
                />
                days
              </Box>
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <Autocomplete
                disablePortal
                id="period-select"
                options={[{ value: -1, label: "Custom" } as PeriodType, ...Period]}
                fullWidth
                size="small"
                onChange={(event, newValue: PeriodType | null) => {
                  if (newValue) {
                    if (newValue.value === -1) {
                      formik.setFieldValue("parentId", newValue.value);
                    } else {
                      formik.setFieldValue("index", newValue.index || 0);
                      formik.setFieldValue("startDate", newValue.startDate || "");
                      formik.setFieldValue("endDate", newValue.endDate || "");
                      formik.setFieldValue("daysOnly", newValue.daysOnly || false);
                      formik.setFieldValue("displayLabel", newValue.displayLabel || "");
                    }
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <CustomLabel text={t("text.Period")} required={false} />
                    }
                  />
                )}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <TextField
                type="date"
                id="fromDate"
                name="fromDate"
                label={
                  <CustomLabel text={t("text.FromDate")} required={false} />
                }
                value={formik.values.fromDate}
                placeholder={t("text.FromDate")}
                size="small"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                disabled={formik.values.parentId !== -1}
                InputProps={{
                  readOnly: formik.values.parentId !== -1,
                }}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <TextField
                type="date"
                id="toDate"
                name="toDate"
                label={<CustomLabel text={t("text.ToDate")} required={false} />}
                value={formik.values.toDate}
                placeholder={t("text.ToDate")}
                size="small"
                fullWidth
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                disabled={formik.values.parentId !== -1}
                InputProps={{
                  readOnly: formik.values.parentId !== -1,
                }}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <CustomMultiSelectAutocomplete
                options={[{ value: "-1", label: "Select All" }, ...option.filter(opt => opt.value !== "-1")]}
                label={t("text.VehicleType")}
                onChange={handleVehicleTypeChange}
                value={option.filter(opt => vType.includes(opt.value))}
              />
            </Grid>

            <Grid item xs={12} sm={4} lg={4}>
              <CustomMultiSelectAutocomplete
                options={[{ value: -1, label: "Select All" }, ...VnoOption.filter(opt => opt.value !== -1)]}
                label={t("text.VehicleNos1")}
                onChange={handleVehicleNoChange}
                value={VnoOption.filter(opt => vNO.includes(opt.value))}
              />
            </Grid>

            <Grid item xs={12} sm={4} lg={4}>
              <Autocomplete
                disablePortal
                id="department-select"
                options={IsDept}
                fullWidth
                size="small"
                onChange={(event: any, newValue: OptionType | null) => {
                  formik.setFieldValue('DeptName', newValue?.label || "")
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <CustomLabel
                        text={t("text.SelectDepartment")}
                        required={false}
                      />
                    }
                  />
                )}
              />
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <Button
                type="submit"
                fullWidth
                style={{
                  backgroundColor: `var(--header-background)`,
                  color: "white",
                  marginTop: "10px",
                }}
                onClick={() => {
                  const selectedPeriod = formik.values.fromDate ? formik.values.fromDate : formik.values.index;

                  if (!selectedPeriod) {
                    alert("Please select a period or custom date");
                  } else {
                    fetchZonesData();
                    setVisible(true);
                  }
                }}
                startIcon={<VisibilityIcon />}
              >
                Show
              </Button>
            </Grid>

            <Grid xs={12} sm={4} md={4} item>
              <Button
                type="button"
                fullWidth
                style={{
                  backgroundColor: `#f44336`,
                  color: "white",
                  marginTop: "10px",
                }}
                startIcon={<RefreshIcon />}
                onClick={() => {
                  formik.resetForm();
                  setVno([]);
                  setVType([]);
                }}
              >
                Reset
              </Button>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Button
                type="button"
                fullWidth
                style={{
                  backgroundColor: "#4caf50",
                  color: "white",
                  marginTop: "10px",
                }}
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
              >
                Download
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            container
            spacing={2}
            sx={{ marginTop: "3%", justifyContent: "center" }}
          >
            {visible && (
              <Grid item xs={12} sm={12} lg={12}>
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <DataGrid
                    rows={zones}
                    columns={columns}
                    rowSpacingType="border"
                    autoHeight
                    slots={{
                      toolbar: GridToolbar,
                    }}
                    pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                      value: size,
                      label: `${size}`,
                    }))}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 5 } },
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    sx={{
                      border: 0,
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#42b6f5",
                        color: "white",
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        color: "white",
                        fontSize: '14px'
                      },
                      "& .MuiDataGrid-cell": {
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      },
                    }}
                  />
                )}
              </Grid>
            )}
          </Grid>

          <Modal open={Shows} onClose={() => setShows(false)}>
            <Box sx={style}>
              {IsRep ? (
                <embed
                  src={`data:application/pdf;base64,${IsRep}`}
                  type="application/pdf"
                  style={{ width: "100%", height: "100%" }}
                />
              ) : (
                <img
                  src={nopdf}
                  alt="No Preview"
                  style={{ width: "100%", height: "100%" }}
                />
              )}
            </Box>
          </Modal>
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
};

export default VehicleTrack;